import { boardDetail, boardDetailProps, resBoardDetail } from '@/api/server/board/read';
import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import TopBackButton from '@/component/common/top-back-button';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { fontWeight } from '@/theme';
import DangerouslySetInnerHTML from '@/lib/DangerouslySetInnerHTML';
import ErrorRes from '@/api/server/ErrorRes';
type resProps = {
  ret_code: number;
  msg: string;
  data: {
    postMap: resBoardDetail;
    fileList: [];
  };
};
export default function NoticeDetail() {
  const navigate = useNavigate();
  const { path } = useParams();
  const [view, setView] = useState<resBoardDetail>();
  const fileList = useRef([]);

  useEffect(() => {
    if (!path) {
      alert('존재하지 않습니다.');
      navigate(-1);
      return;
    }
    (async () => {
      const id = path;
      const type = 'notice' as const;
      const paylaod: boardDetailProps = {
        board_type: type,
        board_id: id,
      };
      const re: resProps = await boardDetail(paylaod);
      if (re.ret_code !== 200) {
        ErrorRes({ code: re.ret_code, msg: re.msg });
        return;
      }
      setView(re.data.postMap);
      fileList.current = re.data.fileList;
    })();
    return () => {};
  }, [path, navigate]);

  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: '812px',
        height: '100vh',
        position: 'relative',
      }}
    >
      <TopBackButton
        title="공지사항"
        boxProps={{
          mb: 4,
        }}
      />

      {view ? (
        <>
          <Typography
            variant="h6"
            sx={{
              wordBreak: 'keep-all',
            }}
            fontWeight={fontWeight.Bold}
          >
            {view.title}
          </Typography>
          <Divider sx={{ my: 3 }} />
          {/* <Typography
            variant="body1"
            sx={{
              color: SFPalette.grey2,
              wordBreak: 'keep-all',
            }}
          > */}
          <DangerouslySetInnerHTML
            html={{
              __html: view.post,
            }}
          />
          {/* </Typography> */}
        </>
      ) : (
        ''
      )}
    </Container>
  );
  // return <>{view}</>;
}
